/** @format */

import React from "react";
import { Box, Container as MuiContainer } from "@mui/material";
import { useTranslation } from "react-i18next";
import {
	VerifiedUser,
	CreditCard,
	ReceiptLong,
	NotificationsActive,
	Schedule,
	FileDownload,
} from "@mui/icons-material";

import {
	Container,
	GradientOverlay,
	FloatingElement,
	HeaderDiv,
	AnimatedBadge,
	MainTitle,
	HighlightText,
	SectionSubtitle,
	ContentWrapper,
	FeatureCard,
	IconCircle,
	IconWrapper,
	FeatureTitle,
	FeatureDescription,
	BottomNote,
	CTAWrapper,
	PrimaryCTA,
	SecondaryCTA,
} from "./styles";

const WhySafer = () => {
	const { t } = useTranslation("home");
	const features = [
		{
			icon: <VerifiedUser />,
			title: t("whySafer.feature1"),
			description: t("whySafer.feature1Desc"),
		},
		{
			icon: <CreditCard />,
			title: t("whySafer.feature2"),
			description: t("whySafer.feature2Desc"),
		},
		{
			icon: <ReceiptLong />,
			title: t("whySafer.feature3"),
			description: t("whySafer.feature3Desc"),
		},
		{
			icon: <NotificationsActive />,
			title: t("whySafer.feature4"),
			description: t("whySafer.feature4Desc"),
		},
		{
			icon: <Schedule />,
			title: t("whySafer.feature5"),
			description: t("whySafer.feature5Desc"),
		},
		{
			icon: <FileDownload />,
			title: t("whySafer.feature6"),
			description: t("whySafer.feature6Desc"),
		},
	];

	return (
		<Container>
			<GradientOverlay />

			{/* Ambient floating glass orbs */}
			<FloatingElement sx={{ top: "12%", left: "6%", animationDelay: "0s" }} />
			<FloatingElement sx={{ top: "55%", right: "7%", animationDelay: "2s" }} />
			<FloatingElement
				sx={{ bottom: "16%", left: "14%", animationDelay: "4s" }}
			/>

			<MuiContainer maxWidth="xl">
				<HeaderDiv data-aos="fade-up">
					<AnimatedBadge>{t("whySafer.title")}</AnimatedBadge>

					<MainTitle>
						{t("whySafer.subtitle")} <HighlightText>{t("whySafer.headline")}</HighlightText>
					</MainTitle>

					<SectionSubtitle>
						{t("whySafer.description")}
					</SectionSubtitle>
				</HeaderDiv>

				<ContentWrapper>
					<Box
						sx={{
							display: "grid",
							gridTemplateColumns: {
								xs: "1fr",
								sm: "repeat(2, 1fr)",
								md: "repeat(3, 1fr)",
							},
							gap: 3,
							padding: "28px 0 10px 0",
						}}>
						{features.map((feature, index) => (
							<FeatureCard
								key={index}
								data-aos="fade-up"
								data-aos-duration="1000"
								data-aos-delay={index * 90}>
								<IconCircle>
									<IconWrapper>{feature.icon}</IconWrapper>
								</IconCircle>

								<FeatureTitle>{feature.title}</FeatureTitle>
								<FeatureDescription>{feature.description}</FeatureDescription>
							</FeatureCard>
						))}
					</Box>

					<CTAWrapper data-aos="fade-up" data-aos-delay="200">
						<PrimaryCTA href="/circle/sign-up">{t("whySafer.cta1")}</PrimaryCTA>
						<SecondaryCTA href="/products/savings-circles">
							{t("whySafer.cta2")}
						</SecondaryCTA>
					</CTAWrapper>

					<BottomNote data-aos="fade-up" data-aos-delay="260">
						{t("whySafer.disclaimer")}
					</BottomNote>
				</ContentWrapper>
			</MuiContainer>
		</Container>
	);
};

export default WhySafer;
